import { Flame } from '@phosphor-icons/react';
import { Switch } from './ui/switch';
import './small-atoms.css';
import { useTranslation } from '../i18n/I18nContext';

/**
 * SpecialOffersFilter - toggle для показа только машин со special offer
 *
 * Показывает машины с isHotOffer === true (те, у которых есть бейдж "HOT").
 * Визуально выделяется Flame-иконкой в акцентном цвете темы; текст лейбла
 * остаётся в стандартной типографике Switch (дизайнер: единый вид шрифта
 * у всех фильтров, цвет меняет только иконка).
 */
const SpecialOffersFilter = ({ checked, onChange, className = '' }) => {
  const { t } = useTranslation();
  // Отдельная переменная темы для иконки — можно задать на уровне организации
  // через widget config (colors.specialOffers), либо оставить дефолтный amber.
  const iconColor = 'var(--theme-accent, #f59e0b)';
  return (
    <div className={`filter-inline ${className}`.trim()}>
      <Switch
        id="special-offers-switch"
        checked={checked}
        onChange={onChange}
        label={
          <span className="filter-inline__label">
            <Flame size={14} weight="bold" fill="currentColor" style={{ color: iconColor }} />
            {t('showcase.catalog.specialOffers', 'Special offers')}
          </span>
        }
      />
    </div>
  );
};

export default SpecialOffersFilter;
